"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWorldState = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const createWorldState = ({ agility, bagItemInstanceIDs, bodyItemInstanceID, boostItemInstanceIDs, clothesDyeItemInstanceID, defense, experienceUntilLevel, hairDyeItemInstanceID, headItemInstanceID, intelligence, inventoryGold, luck, mainHandItemInstanceID, maskItemInstanceID, offHandItemInstanceID, outfitItemInstanceID, strength, timePlayed, wisdom, worldCharacterID, }) => new pixel_pigeon_1.State({
    agility,
    bagItemInstanceIDs,
    bodyItemInstanceID: bodyItemInstanceID !== null && bodyItemInstanceID !== void 0 ? bodyItemInstanceID : null,
    boostItemInstanceIDs,
    clothesDyeItemInstanceID: clothesDyeItemInstanceID !== null && clothesDyeItemInstanceID !== void 0 ? clothesDyeItemInstanceID : null,
    defense,
    experienceUntilLevel: experienceUntilLevel !== null && experienceUntilLevel !== void 0 ? experienceUntilLevel : null,
    hairDyeItemInstanceID: hairDyeItemInstanceID !== null && hairDyeItemInstanceID !== void 0 ? hairDyeItemInstanceID : null,
    headItemInstanceID: headItemInstanceID !== null && headItemInstanceID !== void 0 ? headItemInstanceID : null,
    intelligence,
    inventoryGold,
    lastPianoNoteAt: null,
    lastUsedEmoteID: null,
    luck,
    mainHandItemInstanceID: mainHandItemInstanceID !== null && mainHandItemInstanceID !== void 0 ? mainHandItemInstanceID : null,
    maskItemInstanceID: maskItemInstanceID !== null && maskItemInstanceID !== void 0 ? maskItemInstanceID : null,
    offHandItemInstanceID: offHandItemInstanceID !== null && offHandItemInstanceID !== void 0 ? offHandItemInstanceID : null,
    outfitItemInstanceID: outfitItemInstanceID !== null && outfitItemInstanceID !== void 0 ? outfitItemInstanceID : null,
    pianoNotes: [],
    pianoSessionID: null,
    strength,
    timePlayed: {
        amount: timePlayed,
        updatedAt: (0, pixel_pigeon_1.getCurrentTime)(),
    },
    wisdom,
    worldCharacterID,
});
exports.createWorldState = createWorldState;
